import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-thumb-down",
  templateUrl: "./med-icon-thumb-down.component.html",
})
export class MedIconThumbDownComponent extends SvgMixinComponent {}
